import React, { useState, useContext, useEffect } from 'react';
import { useBreakpoint } from '../misc/useBreakpoint';
import { UserContext } from '../contexts/UserProvider';

const VideoModal = ({ src, isVisible, setIsVisible }) => {
  const { } = useContext(UserContext);
  const { isMobileAndBelow } = useBreakpoint();
  const videoKey = React.useMemo(() => src, [src]);
  const [videoLoaded, setVideoLoaded] = useState(false);

  const CONTAINER_STYLE = { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: isMobileAndBelow ? '100dvh' : '95vh', width: isMobileAndBelow ? '100%' : '80%', maxWidth: '600px', margin: isMobileAndBelow ? '0' : 'auto', backgroundColor: 'transparent', padding: !isMobileAndBelow ? '0' : '1rem', borderRadius: isMobileAndBelow ? '0' : '10px',  position: 'relative',  }
 

  if ( !isVisible ) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255, 0.7)', backdropFilter: 'blur(5px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>

        <div style={{ position: 'absolute', top: '2rem', right: '2rem', zIndex: 10 }}>
          <button 
            onClick={() => setIsVisible(false)} 
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '2.5rem', color: 'var(--color-text3)', padding: '5px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px' }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
          >
            ✕
          </button>
        </div>

      <div style={CONTAINER_STYLE}>
        <div style={{ display: videoLoaded ? 'flex' : 'none', width: '100%', borderRadius: '10px', alignItems: "center", justifyContent: "center", overflow: "hidden", flexDirection: "column" }}>
          <div style={{ display: 'flex', flex: 1, width: '100%', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', padding: '1rem' }}>
            <video 
              key={videoKey}
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }} 
              autoPlay 
              // loop 
              // muted 
              playsInline
              controls
              onLoadedData={() => setVideoLoaded(true)}
            >
              <source src={src} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
